import { TranslationKeys } from '~frontend-common/i18n/english/electrical-details.i18n';

const keys: TranslationKeys = {
  electricalDetails: {
    amperage: {
      choices: {
        amperage100A: '100A',
        amperage200A: '200A',
        amperage60A: '60A',
      },
    },
    panelType: {
      choices: {
        breakers: 'Disjoncteurs',
        fuses: 'Fusibles',
      },
      helper: {
        cells: {
          breakers: {
            description:
              "Un disjoncteur protège le circuit électrique en interrompant le flux de courant dans le cas d'une surcharge électrique. Un disjoncteur ressemble généralement à une petite boîte munie d'un interrupteur. On les retrouve principalement dans les bâtiments récents.",
            title: 'Disjoncteurs',
          },
          fuses: {
            description:
              'Un fusible protège le circuit électrique en fondant en cas de surcharge électrique. Il existe plusieurs types de fusibles: cylindrique, en tube, vis etc. On les retrouve principalement dans les bâtiments plus vieux.',
            title: 'Fusibles',
          },
        },
        title: 'Quel est le type de panneau électrique?',
      },
    },

    titles: {
      panelType: 'Quel est le type de panneau électrique?',
    },
  },
};

export default keys;
